import { useSessionPermission } from '@btime/react-session'

const PERMISSIONS = {
  checkListCategory: 'setupChecklist'
}

export const useMinicrudsPermission = entity => {
  const permission = PERMISSIONS[entity] ?? 'setupServiceOrder'

  const hasAddPermission = useSessionPermission(permission)

  return hasAddPermission
}
